export const europeCountriesIds = [
  'ESP', 'PRT', 'AUT', 'SWZ', 'IRL', 'ISL', 'NOR', 'SWE', 'FIN',
  'LTU', 'LUX', 'LVA', 'EST', 'BLR', 'UKR', 'MDA', 'ROU', 'CZE', 'SVK',
  'SRB', 'ALB', 'BGR', 'MNG', 'CYP', 'HRV', 'BIH', 'MNE',
  'MKD', 'XKX', 'SVN', 'CHE'
]
export const mainCountriesIds = [
  'BEL', 'POL', 'DEU', 'FRA', 'ITA', 'GRC', 'UK', 'NLD', 'DNK', 'HUN'
]
export const countriesMarkers = [
  {
    coordinates: [20, 59.5],
    width: 53,
    text: 'Poland'
  },
  {
    coordinates: [20.5, 53.5],
    width: 64,
    text: 'Hungary'
  },
  {
    coordinates: [25.5, 44],
    width: 55,
    text: 'Greece'
  },
  {
    coordinates: [12, 48.5],
    width: 55,
    text: 'Italy'
  },
  {
    coordinates: [13, 57],
    width: 64,
    text: 'Germany'
  },
  {
    coordinates: [9, 61],
    width: 64,
    text: 'Denmark'
  },
  {
    coordinates: [-1.5, 57],
    width: 110,
    text: 'United Kingdom'
  },
  {
    coordinates: [3, 54.3],
    width: 55,
    text: 'France'
  },
  {
    coordinates: [3, 58.2],
    width: 90,
    text: 'Netherlands'
  },
  {
    coordinates: [2.5, 56.2],
    width: 70,
    text: 'Belgium'
  }
]

export const countryData = [
  [
    {
      name: 'Belgium',
      polarisation: -0.08,
      resilience: 0.25
    },
    {
      name: 'Denmark',
      polarisation: 0.04,
      resilience: 0.32
    },
    {
      name: 'France',
      polarisation: 0.15,
      resilience: 0.20
    },
    {
      name: 'Germany',
      polarisation: -0.13,
      resilience: 0.27
    },
    {
      name: 'Greece',
      polarisation: 0.39,
      resilience: -0.32
    },
    {
      name: 'Hungary',
      polarisation: 0.46,
      resilience: -0.57
    },
    {
      name: 'Italy',
      polarisation: 0.15,
      resilience: -0.35
    },
    {
      name: 'Netherlands',
      polarisation: 0.32,
      resilience: -0.03
    },
    {
      name: 'Poland',
      polarisation: -0.76,
      resilience: -0.48
    },
    {
      name: 'United Kingdom',
      polarisation: -0.57,
      resilience: 0.72
    }
  ],
  [
    {
      name: 'Belgium',
      polarisation: 0,
      resilience: -0.05
    },
    {
      name: 'Denmark',
      polarisation: -0.07,
      resilience: 0.06
    },
    {
      name: 'France',
      polarisation: 0.07,
      resilience: -0.06
    },
    {
      name: 'Germany',
      polarisation: -0.03,
      resilience: 0.5
    },
    {
      name: 'Greece',
      polarisation: 0.4,
      resilience: -0.51
    },
    {
      name: 'Hungary',
      polarisation: 0.24,
      resilience: -0.37
    },
    {
      name: 'Italy',
      polarisation: 0.14,
      resilience: -0.16
    },
    {
      name: 'Netherlands',
      polarisation: -0.17,
      resilience: 0.15
    },
    {
      name: 'Poland',
      polarisation: 0.22,
      resilience: -0.34
    },
    {
      name: 'United Kingdom',
      polarisation: -0.55,
      resilience: 0.68
    }
  ],
  [
    {
      name: 'Belgium',
      polarisation: -1.13,
      resilience: 0.19
    },
    {
      name: 'Denmark',
      polarisation: -0.54,
      resilience: 0.68
    },
    {
      name: 'France',
      polarisation: 0.25,
      resilience: -0.25
    },
    {
      name: 'Germany',
      polarisation: -0.29,
      resilience: 0.33
    },
    {
      name: 'Greece',
      polarisation: 0.78,
      resilience: 0.19
    },
    {
      name: 'Hungary',
      polarisation: 0.12,
      resilience: -0.98
    },
    {
      name: 'Italy',
      polarisation: 0.63,
      resilience: -0.10
    },
    {
      name: 'Netherlands',
      polarisation: -0.72,
      resilience: 0.37
    },
    {
      name: 'Poland',
      polarisation: -0.10,
      resilience: -0.45
    },
    {
      name: 'United Kingdom',
      polarisation: -0.03,
      resilience: 0.03
    }
  ],
  [
    {
      name: 'Belgium',
      polarisation: -0.42,
      resilience: 0.51
    },
    {
      name: 'Denmark',
      polarisation: -0.9,
      resilience: 0.62
    },
    {
      name: 'France',
      polarisation: -0.17,
      resilience: -0.1
    },
    {
      name: 'Germany',
      polarisation: -0.41,
      resilience: 0.19
    },
    {
      name: 'Greece',
      polarisation: 0.83,
      resilience: -0.57
    },
    {
      name: 'Hungary',
      polarisation: 0.73,
      resilience: -0.49
    },
    {
      name: 'Italy',
      polarisation: 0.77,
      resilience: -0.31
    },
    {
      name: 'Netherlands',
      polarisation: -0.76,
      resilience: 0.4
    },
    {
      name: 'Poland',
      polarisation: 0.57,
      resilience: -0.69
    },
    {
      name: 'United Kingdom',
      polarisation: -0.26,
      resilience: 0.43
    }
  ],
  [
    {
      name: 'Belgium',
      polarisation: -0.18,
      resilience: -0.08
    },
    {
      name: 'Denmark',
      polarisation: -1.07,
      resilience: 0.37
    },
    {
      name: 'France',
      polarisation: 0.59,
      resilience: 0.3
    },
    {
      name: 'Germany',
      polarisation: -0.36,
      resilience: 0.38
    },
    {
      name: 'Greece',
      polarisation: 0.99,
      resilience: -0.56
    },
    {
      name: 'Hungary',
      polarisation: 0.33,
      resilience: -0.34
    },
    {
      name: 'Italy',
      polarisation: 0.38,
      resilience: 0.07
    },
    {
      name: 'Netherlands',
      polarisation: -1.07,
      resilience: 0.22
    },
    {
      name: 'Poland',
      polarisation: 0.08,
      resilience: -0.46
    },
    {
      name: 'United Kingdom',
      polarisation: 0.31,
      resilience: 0.1
    }
  ]
]

export const nameToId = {
  Belgium: 'BEL',
  Poland: 'POL',
  Germany: 'DEU',
  France: 'FRA',
  Italy: 'ITA',
  Greece: 'GRC',
  'United Kingdom': 'UK',
  Netherlands: 'NLD',
  Denmark: 'DNK',
  Hungary: 'HUN'
}

export const excels = [{
  polarisation: 'BRaVE Ethnic Racial Polarisation Raw Data.xlsx',
  resilience: 'BRaVE Ethnic Racial Resilience Raw Data.xlsx'
},
{
  polarisation: 'BRaVE Religious Polarisation Raw Data.xlsx',
  resilience: 'BRaVE Religious Resilience Raw Data.xlsx'
},
{
  polarisation: 'BRaVE Political Polarisation Raw Data.xlsx',
  resilience: 'BRaVE Political Resilience Raw Data.xlsx'
},
{
  polarisation: 'BRaVE Gender Sexuality Polarisation Raw Data.xlsx',
  resilience: 'BRaVE Gender Sexuality Resilience Raw Data.xlsx'
},
{
  polarisation: 'BRaVE Socioeconomic Polarisation Raw Data.xlsx',
  resilience: 'BRaVE Socioeconomic Resilience Raw Data.xlsx'
}]



// WEBPACK FOOTER //
// ./src/components/ToolkitComponent/mapData.js